import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState({
        home: false,
        services: false
    });

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        document.body.classList.remove("hero-anime");
        // Prevent scrolling when mobile menu is open
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isMobileMenuOpen]);

    const handleMouseEnterLeave = (menuItem) => {
        setDropdownOpen((prevState) => ({
            ...prevState,
            [menuItem]: !prevState[menuItem]
        }));
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            <div className="hero-anime">
                <div className={`navigation-wrap bg-light start-header ${isScrolled ? "scroll-on" : "start-style"}`}>
                    <div className="header-container">
                        <div className="row">
                            <div className="col-12">
                                <nav className="navbar navbar-expand-md navbar-light">
                                    <Link className="navbar-brand" to="/" onClick={closeMobileMenu}>
                                        <img src="/img/robo_logo.png" alt="robo analytics" />
                                    </Link>

                                    {/* Mobile Menu Button */}
                                    <button 
                                        className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                        aria-label="Toggle mobile menu"
                                    >
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>

                                    <div className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`}>
                                        <ul className="navbar-nav ml-auto py-4 py-md-0">
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/" onClick={closeMobileMenu}>
                                                    Home
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/portfolio" onClick={closeMobileMenu}>
                                                    Portfolio
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/career" onClick={closeMobileMenu}>
                                                    Career
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/our-services" onClick={closeMobileMenu}>
                                                    Services
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className="nav-link" to="/contact" onClick={closeMobileMenu}>
                                                    Contact
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
